import ax from "axios"
import { Routes } from "src/constants"

/**
 * @description import this instance of axios to utilise interceptors
 */
const axios = ax.create()
axios.interceptors.response.use(
  data => {
    return data
  },
  error => {
    // console.log(error.toJSON())
    if (error.response.headers["content-type"] == "application/json") {
      const jsonRes =
        typeof error.response.data === "object"
          ? error.response.data
          : JSON.parse(error.response.data)
      if (
        error.response.status == 403 &&
        jsonRes.reason === "Email not verified."
      ) {
        // redirect to verify
        // react router isn't available here so we use window.location.href
        window.location.href = Routes.VERIFY
      }
    }
    return Promise.reject(error)
  }
)

export default axios
